// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Local library
import {
  IReplays,
  WagerFacade
} from '@amwager/wager/data-access';
import {
  DateFormatPipe,
  NumberWithCommasPipe
} from '@amwager/util';

// Third party
import _ from 'lodash';

// Ionic
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonSpinner,
  IonTitle,
  IonToolbar,
  ModalController
} from '@ionic/angular/standalone';

@Component({
  selector: 'feature-ion-runner-replays',
  templateUrl: './runner-replays.component.html',
  styleUrls: ['./runner-replays.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    DateFormatPipe,
    NumberWithCommasPipe,
    IonContent,
    IonToolbar,
    IonHeader,
    IonButton,
    IonButtons,
    IonSpinner,
    IonTitle,
    IonIcon
  ]
})
export class RunnerReplaysModalComponent implements OnInit {

  isLoadingReplays: boolean = true;
  indexGetReplays: any;
  indexCountReplays: number = 0;
  runnerWithReplays: any;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly wagerFacade: WagerFacade,
    private modalCtrl: ModalController
  ) {

    this.wagerFacade.getReplays$()
    .subscribe((replays?: IReplays) => {

      if (replays?.isSuccess !== undefined)
        this.indexCountReplays = this.indexCountReplays + 1;

      if (replays?.response !== undefined && replays?.isSuccess !== undefined) {

        const availableVideos = replays?.response?.AvailableVideos;

        _.flatMap(availableVideos, (event) => {
          _.map(event, (item, breed) => {
            _.map(item, (data) => {
              const video = {
                track: data?.EventName,
                trackId: data?.TrackId,
                date: data?.RaceDay,
                breed,
                race: data?.RaceId,
                distance: data?.Distance,
                surface: data?.Surface,
                purse: data?.Purse,
              };

              const runner = this.runnerWithReplays[this.indexCountReplays-1];
              runner.availableReplays = [...runner.availableReplays, video];

            });
          });
        });

        this.runnerWithReplays.forEach((runner: { availableReplays: any[]; }) => {
          runner.availableReplays = _.orderBy(
            runner.availableReplays,
            ['date', 'race', 'track'],
            ['desc', 'asc', 'asc']
          );
        });

      }

      if (this.indexGetReplays === this.indexCountReplays)
        this.isLoadingReplays = false;

      this.cdRef.markForCheck();
    });

  }

  ngOnInit() {
    this.indexCountReplays = 0;
  }


  getReplayVideo(replay: any): void {
    this.wagerFacade.getEventRaceVideoReplay(
      'RunnerReplaysModalComponent:getReplayVideo',
      {
        toteEventId: replay?.trackId,
        toteRaceId: replay?.race,
        raceDay: this.toDate(new Date(replay?.date), 2),
        width: 640,
        height: 500
      }
    );

    this.wagerFacade.setSelectedReplayInfo(
      replay?.track, replay?.date, replay?.breed, replay?.race
    );
  }

  toDate(date: Date, format: number = 1): string {
    const month = _.padStart(String(date.getMonth()+1), 2, '0');
    const day = _.padStart(String(date.getDate()), 2, '0');

    if(format == 2) return month + "-" + day + "-" + date.getFullYear();
    else return date.getFullYear() + "-" + month + "-" + day;
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

}
